import React from 'react'
import { ElementProps } from '../base/element'
import { Button, IButtonComponent } from './button'

export interface ILinkComponent extends IButtonComponent {
    type: 'link'
    href: string,
    openInNewTab?: boolean,
  }
  

export const Link = (props: ElementProps) => {

  return (
    <Button {...props} / >
  )
}
